/**
 *
 * https://komutteknolojisi.com
 *
 * @author Goncanur Uz <goncanur@komutteknolojisi.com>
 */
import { call } from "@redux-saga/core/effects";
import { put } from "@redux-saga/core/effects";
import { hideLoader, showLoader } from "../store/loading/loadingSlice";
import { createRequestSaga } from "./baseRequest";
import { ApiResponse, SagaGenericParams, verfiyResponse } from "./types";

export function* deleteSaga<Type>({ payload, url }: SagaGenericParams<Type>) {
  yield put(showLoader());
  try {
    const response: ApiResponse<Type> = yield call(createRequestSaga, {
      method: "DELETE",
      url: url || "",
    });
    if (verfiyResponse(response))
      payload.onSuccess(
        response.Message,
        response.Result,
        response,
        response.Translates
      );
    else {
      payload.onError(response.Message);
    }
  } catch (e) {
    console.log("ERROR getListSaga" + url, e);
  } finally {
    payload.onFinally && payload.onFinally();
    yield put(hideLoader());
  }
}
